import { TableHead, TableTitle } from '@genial/components';
import * as NB from 'native-base';

import { columnWidthsDesktop, columnWidthsTablet } from '../constants';

export const Head = () => {
  const deviceType = NB.useBreakpointValue({ md: 'desktop', sm: 'tablet' });

  return (
    <TableHead testId="header">
      <TableTitle
        textAlign="center"
        width={deviceType === 'desktop' ? columnWidthsDesktop.icon : columnWidthsTablet.icon}
        testId="header-icon">
        #
      </TableTitle>
      <TableTitle
        textAlign="start"
        width={deviceType === 'desktop' ? columnWidthsDesktop.sendId : columnWidthsTablet.sendId}
        testId="header-id">
        ID Solicitação
      </TableTitle>
      <TableTitle
        textAlign="start"
        width={
          deviceType === 'desktop'
            ? columnWidthsDesktop.monthCompetence
            : columnWidthsTablet.monthCompetence
        }
        testId="header-month-competence">
        Mês de competência
      </TableTitle>
      <TableTitle
        textAlign="start"
        width={deviceType === 'desktop' ? columnWidthsDesktop.type : columnWidthsTablet.type}
        testId="header-type">
        Tipo
      </TableTitle>
      <TableTitle
        textAlign="start"
        width={
          deviceType === 'desktop'
            ? columnWidthsDesktop.billedCustomers
            : columnWidthsTablet.billedCustomers
        }
        testId="header-billed-customers">
        Clientes
      </TableTitle>
      <TableTitle
        textAlign="start"
        width={
          deviceType === 'desktop' ? columnWidthsDesktop.sendDate : columnWidthsTablet.sendDate
        }
        testId="header-send-date">
        Data de envio
      </TableTitle>
      <TableTitle
        textAlign="start"
        width={deviceType === 'desktop' ? columnWidthsDesktop.total : columnWidthsTablet.total}
        testId="header-total">
        Total(R$)
      </TableTitle>
      <TableTitle
        textAlign="start"
        width={deviceType === 'desktop' ? columnWidthsDesktop.status : columnWidthsTablet.status}
        testId="header-status">
        Status
      </TableTitle>
      <TableTitle
        width={deviceType === 'desktop' ? columnWidthsDesktop.actions : columnWidthsTablet.actions}
        testId="header-actions"
      />
    </TableHead>
  );
};
